import script from "./NiceSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./NiceSelect.vue?vue&type=script&setup=true&lang=js"

import "./NiceSelect.vue?vue&type=style&index=0&id=7479296b&lang=css"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QItemLabel});
